<template>
  <div class="nav-buttons-side">
    <router-link to="/">{{ data.title }}</router-link>
    <BaseIcon class="nav-buttons-side__icon" name="chevron_right" size="22"></BaseIcon>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
export default {
  name: 'SideNavButton',
  components: { BaseIcon },
  props: ['data']
}
</script>

<style lang="postcss">
.nav-buttons-side {
  @apply border border-t-0 border-l-0 border-r-0 border-body-lighter text-secondary relative;
}
.nav-buttons-side a {
  @apply block py-4 pr-4 text-secondary no-underline font-semibold;
}
.nav-buttons-side a:hover {
  @apply text-primary;
}
.nav-buttons-side.current,
.nav-buttons-side.current a {
  @apply text-body;
}
.nav-buttons-side .nav-buttons-side__icon {
  @apply hidden;
}
.nav-buttons-side.current .nav-buttons-side__icon {
  @apply block fill-current absolute right-0;
  top: calc(50% - 12px);
}
</style>
